import { useEffect, useState } from 'react';
import { useClient } from '../context/ClientStatusContext';
import { ClientStatus } from '../model/ClientStatus';
import PolozkaCiselnik from '../model/ciselniky/PolozkaCiselnik';
import { fetchCiselnikPolozky } from '../client/external/ciselniky/ciselnikPolozkaClient';
import { CiselnikPolozkaFilterSearch } from '../model/CiselnikPolozkaFilterSearch';

interface ReturnType {
  polozkyCiselnik: PolozkaCiselnik[];
  polozkyCiselnikStatus: ClientStatus;
}

export default (
  searchParams: CiselnikPolozkaFilterSearch,
): ReturnType => {
  const {
    hladanyNazov, kody, limit, platny, typy, ids, execute = true,
  } = searchParams;
  const [, setAction] = useState(0);
  const { wrapClient, status, data } = useClient(fetchCiselnikPolozky);

  useEffect(() => {
    setAction(prevState => {
      clearTimeout(prevState);
      return prevState;
    });

    const act = setTimeout(async () => {
      if (execute) {
        await wrapClient(ids, typy, platny, hladanyNazov, kody, limit);
      }
    }, 300);

    // @ts-ignore
    setAction(act);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hladanyNazov, limit, execute]);
  return {
    polozkyCiselnik: data || [],
    polozkyCiselnikStatus: status,
  };
};
